<script>
    const constantes =
        {
            carreras_profesionales:[
                {'codigo':'32','carrera':'INGENIERÍA CIVIL'},
                {'codigo':'33','carrera':'ARQUITECTURA Y URBANISMO'},
                {'codigo':'34','carrera':'CIENCIAS FÍSICO MATEMÁTICAS'},
                {'codigo':'0','carrera':'------------------------------'},
                {'codigo':'1','carrera':'INGENIERÍA AGRONÓMICA'},
                {'codigo':'2','carrera':'INGENIERÍA AGROINDUSTRIAL'},
                {'codigo':'3','carrera':'INGENIERÍA TOPOGRÁFICA Y AGRIMENSURA'},
                {'codigo':'4','carrera':'MEDICINA VETERINARIA Y ZOOTECNIA'},
                {'codigo':'5','carrera':'INGENIERÍA ECONÓMICA'},
                {'codigo':'6','carrera':'CIENCIAS CONTABLES'},
                {'codigo':'7','carrera':'ADMINISTRACIÓN'},
                {'codigo':'8','carrera':'ENFERMERÍA'},
                {'codigo':'9','carrera':'TRABAJO SOCIAL'},
                {'codigo':'10','carrera':'INGENIERÍA DE MINAS'},
                {'codigo':'11','carrera':'SOCIOLOGÍA'},
                {'codigo':'12','carrera':'TURISMO'},
                {'codigo':'13','carrera':'ANTROPOLOGÍA'},
                {'codigo':'14','carrera':'CIENCIAS DE LA COMUNICACIÓN SOCIAL'},
                {'codigo':'15','carrera':'BIOLOGÍA'},
                {'codigo':'16','carrera':'EDUCACIÓN SECUNDARIA (CIENCIAS)'},
                {'codigo':'17','carrera':'EDUCACIÓN SECUNDARIA (LETRAS)'},
                {'codigo':'18','carrera':'EDUCACIÓN FÍSICA'},
                {'codigo':'20','carrera':'EDUCACIÓN PRIMARIA'},
                {'codigo':'21','carrera':'EDUCACIÓN INICIAL'},
                {'codigo':'22','carrera':'INGENIERÍA ESTADÍSTICA E INFORMÁTICA'},
                {'codigo':'23','carrera':'INGENIERÍA DE SISTEMAS'},
                {'codigo':'24','carrera':'INGENIERÍA ELECTRÓNICA'},
                {'codigo':'25','carrera':'DERECHO'},
                {'codigo':'26','carrera':'INGENIERÍA QUÍMICA'},
                {'codigo':'27','carrera':'MEDICINA HUMANA'},
                {'codigo':'28','carrera':'NUTRICIÓN HUMANA'},
                {'codigo':'29','carrera':'ODONTOLOGÍA'},
                {'codigo':'30','carrera':'INGENIERÍA METALÚRGICA'},
                {'codigo':'31','carrera':'INGENIERÍA GEOLÓGICA'},

                {'codigo':'35','carrera':'INGENIERÍA AGRÍCOLA'},
                {'codigo':'36','carrera':'INGENIERÍA MECÁNICA ELÉCTRICA'},
                {'codigo':'56','carrera':'ARTE'},

            ],
            cursos:[

                {'curso_id':1,'descripcion':'Estatica'},
                {'curso_id':2,'descripcion':'Matematica basica'},
                {'curso_id':3,'descripcion':'Calculo'},
                {'curso_id':999,'descripcion':'Otros'},


            ],
            carreras_profesionales_habilitadas:[

                /*<option value="32">INGENIERIA CIVIL</option>
                <option value="34">CIENCIAS FÍSICO MATEMÁTICAS</option>
                <option value="33">ARQUITECTURA Y URBANISMO</option>*/
                /*{'codigo':'01','carrera':'INGENIERÍA AGRONÓMICA'},
                {'codigo':'02','carrera':'INGENIERÍA AGROINDUSTRIAL'},
                {'codigo':'03','carrera':'INGENIERÍA TOPOGRÁFICA Y AGRIMENSURA'},
                {'codigo':'04','carrera':'MEDICINA VETERINARIA Y ZOOTECNIA'},
                {'codigo':'05','carrera':'INGENIERÍA ECONÓMICA'},
                {'codigo':'06','carrera':'CIENCIAS CONTABLES'},
                {'codigo':'07','carrera':'ADMINISTRACIÓN'},
                {'codigo':'08','carrera':'ENFERMERÍA'},
                {'codigo':'09','carrera':'TRABAJO SOCIAL'},
                {'codigo':'10','carrera':'INGENIERÍA DE MINAS'},
                {'codigo':'11','carrera':'SOCIOLOGÍA'},
                {'codigo':'12','carrera':'TURISMO'},
                {'codigo':'13','carrera':'ANTROPOLOGÍA'},
                {'codigo':'14','carrera':'CIENCIAS DE LA COMUNICACIÓN SOCIAL'},
                {'codigo':'15','carrera':'BIOLOGÍA'},
                {'codigo':'16','carrera':'EDUCACIÓN SECUNDARIA (CIENCIAS)'},
                {'codigo':'17','carrera':'EDUCACIÓN SECUNDARIA (LETRAS)'},
                {'codigo':'18','carrera':'EDUCACIÓN FÍSICA'},
                {'codigo':'20','carrera':'EDUCACIÓN PRIMARIA'},
                {'codigo':'21','carrera':'EDUCACIÓN INICIAL'},
                {'codigo':'22','carrera':'INGENIERÍA ESTADÍSTICA E INFORMÁTICA'},
                {'codigo':'23','carrera':'INGENIERÍA DE SISTEMAS'},
                {'codigo':'24','carrera':'INGENIERÍA ELECTRÓNICA'},
                {'codigo':'25','carrera':'DERECHO'},
                {'codigo':'26','carrera':'INGENIERÍA QUÍMICA'},
                {'codigo':'27','carrera':'MEDICINA HUMANA'},
                {'codigo':'28','carrera':'NUTRICIÓN HUMANA'},
                {'codigo':'29','carrera':'ODONTOLOGÍA'},
                {'codigo':'30','carrera':'INGENIERÍA METALÚRGICA'},
                {'codigo':'31','carrera':'INGENIERÍA GEOLÓGICA'},*/
                {'codigo':'32','carrera':'INGENIERÍA CIVIL'},
                {'codigo':'33','carrera':'ARQUITECTURA Y URBANISMO'},
                {'codigo':'34','carrera':'CIENCIAS FÍSICO MATEMÁTICAS'},
                /*{'codigo':'35','carrera':'INGENIERÍA AGRÍCOLA'},
                {'codigo':'36','carrera':'INGENIERÍA MECÁNICA ELÉCTRICA'},
                {'codigo':'56','carrera':'ARTE'},*/
            ],
            provincias:[{"id":"01","name":"Amazonas"}, {"id":"02","name":"\u00c1ncash"}, {"id":"03","name":"Apur\u00edmac"}, {"id":"04","name":"Arequipa"}, {"id":"05","name":"Ayacucho"}, {"id":"06","name":"Cajamarca"}, {"id":"07","name":"Callao"}, {"id":"08","name":"Cusco"}, {"id":"09","name":"Huancavelica"}, {"id":"10","name":"Hu\u00e1nuco"}, {"id":"11","name":"Ica"}, {"id":"12","name":"Jun\u00edn"}, {"id":"13","name":"La Libertad"}, {"id":"14","name":"Lambayeque"}, {"id":"15","name":"Lima"}, {"id":"16","name":"Loreto"}, {"id":"17","name":"Madre de Dios"}, {"id":"18","name":"Moquegua"}, {"id":"19","name":"Pasco"}, {"id":"20","name":"Piura"}, {"id":"21","name":"Puno"}, {"id":"22","name":"San Mart\u00edn"}, {"id":"23","name":"Tacna"}, {"id":"24","name":"Tumbes"}, {"id":"25","name":"Ucayali"}],


        }
    ;
    export default constantes;
</script>
